import { useTranslation } from 'react-i18next'

import { REQUEST_ENTITY } from '../../../../../constants/entity'
import { stopPropagation } from '../../../../../utils/events'
import { ActionSelect, getActionSelectOptions } from '../../../../Action'
import Button, { BUTTON_HEIGHT_24 } from '../../../../Button'
import { EntityArchivedIcon, EntityLink } from '../../../../Entity'
import { QA_NAME_REQUEST_BOARD_CARD_ACTIONS } from '../../RequestBoard.constants'

import { getRequestBoardCardNumber } from './RequestBoardCardHead.utils'

import * as styles from './RequestBoardCardHead.module.css'

import Archive2Icon from '../../../../../icons/archive-2.svg'

function RequestBoardCardHead({
  getActions,
  getProfileLink,
  isMenuDisabled,
  item,
  onCallAction,
}) {
  const { archived, id, request_no: requestNo, unread } = item

  const { t } = useTranslation()

  const actions = getActionSelectOptions({
    actions: getActions(item),
    t,
  })

  function handleClickAction(action) {
    onCallAction(action.value, item)
  }

  return (
    <div className={styles.RequestBoardCardHead}>
      {requestNo ? (
        <EntityLink
          className={styles.requestNo}
          entity={REQUEST_ENTITY}
          id={id}
          text={getRequestBoardCardNumber(requestNo)}
          to={getProfileLink(id)}
          unread={unread}
        />
      ) : null}
      <div className={styles.actions}>
        {archived ? <EntityArchivedIcon Icon={Archive2Icon} /> : null}
        {actions.length > 0 ? (
          <ActionSelect
            actions={actions}
            controlProps={{
              buttonProps: {
                Button: Button.Text,
                disabled: isMenuDisabled,
                height: BUTTON_HEIGHT_24,
                qaName: QA_NAME_REQUEST_BOARD_CARD_ACTIONS,
              },
            }}
            disabled={isMenuDisabled}
            qaName={QA_NAME_REQUEST_BOARD_CARD_ACTIONS}
            onClick={stopPropagation}
            onClickAction={handleClickAction}
          />
        ) : null}
      </div>
    </div>
  )
}

export default RequestBoardCardHead
